import { supabase } from '../lib/supabase';

export interface Airport {
  id: string;
  code: string;
  city: string;
  airport: string;
  country: string;
}

// Função para remover acentos
function removeAccents(str: string): string {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export async function searchAirports(query: string): Promise<Airport[]> {
  if (query.length < 3) return [];

  try {
    // Remove acentos da query e converte para minúsculas
    const normalizedQuery = removeAccents(query.toLowerCase());

    const { data, error } = await supabase
      .from('airports')
      .select('*')
      .ilike('city', `%${normalizedQuery}%`)
      .order('city')
      .limit(10);

    if (error) {
      console.error('Supabase error:', error);
      throw error;
    }

    // Agrupa por cidade e pega o primeiro aeroporto de cada cidade
    const groupedByCity = data?.reduce((acc: { [key: string]: Airport }, airport) => {
      const cityKey = removeAccents(airport.city.toLowerCase());
      if (!acc[cityKey]) {
        acc[cityKey] = airport;
      }
      return acc;
    }, {});

    // Converte o objeto agrupado de volta para array e ordena por cidade
    const uniqueCities = Object.values(groupedByCity).sort((a, b) => 
      a.city.localeCompare(b.city)
    );

    return uniqueCities || [];
  } catch (err) {
    console.error('Error searching airports:', err);
    return [];
  }
}